import React from "react";
import "./team.css"; 
import { ImUser } from "react-icons/im";

const TeamTabs = ({ teams, activeTab, onTabClick }) => {
  return (
    <div className="tabs_container">
      {teams.map((team, index) => (
        <button
          key={team.teamId} 
          className={`order_statusbuttons ${activeTab === team.teamId? "active" : ""}`}
          onClick={() => onTabClick(team.teamId)} 
          type="button"
        >
          <ImUser size={20} />
          {team.teamName}
        </button>
      ))}
    </div>
  );
};

export default TeamTabs;
